import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function TrashCan({ color }: IconProps) {
  const theme = useTheme();

  return (
    <svg width='12' height='16' viewBox='0 0 12 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.999837 13.8333C0.999837 14.75 1.74984 15.5 2.6665 15.5H9.33317C10.2498 15.5 10.9998 14.75 10.9998 13.8333V5.5C10.9998 4.58333 10.2498 3.83333 9.33317 3.83333H2.6665C1.74984 3.83333 0.999837 4.58333 0.999837 5.5V13.8333ZM3.6415 7.30833C3.9665 6.98333 4.4915 6.98333 4.8165 7.30833L5.99984 8.49167L7.18317 7.30833C7.50817 6.98333 8.03317 6.98333 8.35817 7.30833C8.68317 7.63333 8.68317 8.15833 8.35817 8.48333L7.17484 9.66667L8.35817 10.85C8.68317 11.175 8.68317 11.7 8.35817 12.025C8.03317 12.35 7.50817 12.35 7.18317 12.025L5.99984 10.8417L4.8165 12.025C4.4915 12.35 3.9665 12.35 3.6415 12.025C3.3165 11.7 3.3165 11.175 3.6415 10.85L4.82484 9.66667L3.6415 8.48333C3.3165 8.16667 3.3165 7.63333 3.6415 7.30833ZM8.9165 1.33333L8.32484 0.741667C8.17484 0.591667 7.95817 0.5 7.7415 0.5H4.25817C4.0415 0.5 3.82484 0.591667 3.67484 0.741667L3.08317 1.33333H0.999837C0.541504 1.33333 0.166504 1.70833 0.166504 2.16667C0.166504 2.625 0.541504 3 0.999837 3H10.9998C11.4582 3 11.8332 2.625 11.8332 2.16667C11.8332 1.70833 11.4582 1.33333 10.9998 1.33333H8.9165Z'
        fill={color || theme.colors.yellow500}
      />
    </svg>
  );
}
